module.exports = __webpack_public_path__ + "img/ella.3bf2c332.svg";